import 'angular';

import { downgradeInjectable } from '@angular/upgrade/static';

import { BusinessIntelligenceDashboardCtrl }      from './business-intelligence.dashboard';
import { BusinessIntelligenceDashboardDirective } from './business-intelligence.dashboard.directive';
import { BusinessIntelligenceService }            from './business-intelligence.service';

angular.module('app-lite.business-intelligence', [])
  .controller('BusinessIntelligenceDashboardCtrl', BusinessIntelligenceDashboardCtrl)
  .directive('biDashboard', BusinessIntelligenceDashboardDirective)
  .service('businessIntelligenceApi', downgradeInjectable(BusinessIntelligenceService));
